export default __webpack_public_path__ + "static/media/boobytrap.b5b10102.png";